import React from "react";
import { Box, Button, Typography, useTheme, Fade } from "@mui/material";
import { MdWarning, MdLogin } from "react-icons/md";
import routing from "../../routing";

/**
 * SessionExpiredOverlay - A simple, elegant overlay shown when a user 
 * logs out from another tab.
 */
const SessionExpiredOverlay = () => {
    const theme = useTheme();

    const handleLogin = () => {
        // Force a full reload to the login page to ensure all state is cleared
        window.location.href = routing.login;
    };

    return (
        <Box
            sx={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                backdropFilter: "blur(8px)",
                zIndex: 9999,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Fade in={true} timeout={500}>
                <Box
                    sx={{
                        backgroundColor: theme.palette.background.paper,
                        borderRadius: 4,
                        padding: 5,
                        maxWidth: 450,
                        width: "90%",
                        textAlign: "center",
                        boxShadow: "0 24px 48px rgba(0,0,0,0.5)",
                        border: `1px solid ${theme.palette.divider}`,
                    }}
                >
                    <Box
                        sx={{
                            width: 80,
                            height: 80,
                            borderRadius: "50%",
                            backgroundColor: `${theme.palette.warning.main}15`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto 24px",
                        }}
                    >
                        <MdWarning size={40} color={theme.palette.warning.main} />
                    </Box>

                    <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: theme.palette.text.primary }}>
                        Session Ended
                    </Typography>

                    <Typography variant="body1" sx={{ mb: 4, color: theme.palette.text.secondary, lineHeight: 1.6 }}>
                        Your session has ended in another tab. Please log in again to continue working safely.
                    </Typography>

                    <Button
                        variant="contained"
                        fullWidth
                        size="large"
                        startIcon={<MdLogin />}
                        onClick={handleLogin}
                        sx={{
                            py: 1.5,
                            fontSize: "1rem",
                            fontWeight: 600,
                            textTransform: "none",
                            borderRadius: 2,
                            backgroundColor: theme.palette.primary.main,
                            "&:hover": {
                                backgroundColor: theme.palette.primary.dark,
                            },
                        }}
                    >
                        Log In Again
                    </Button>
                </Box>
            </Fade>
        </Box>
    );
};

export default SessionExpiredOverlay;
